import { render, staticRenderFns } from "./DispTrendBl.vue?vue&type=template&id=187ca14a&scoped=true&"
import script from "./DispTrendBl.vue?vue&type=script&lang=js&"
export * from "./DispTrendBl.vue?vue&type=script&lang=js&"
import style0 from "./DispTrendBl.vue?vue&type=style&index=0&id=187ca14a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "187ca14a",
  null
  
)

/* custom blocks */
import block0 from "./DispTrendBl.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports